import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {HomeModule} from "./modules/home/home.module";
import {ErroModule} from "./modules/erro/erro.module";
import {CadastroModule} from "./modules/cadastro/cadastro.module";
import {AuthModule} from "./modules/auth/auth.module";
import {AutenticacaoGuard} from "./core/guards/autenticacao-guard";
import {JuridicoModule} from "./modules/juridico/juridico.module";
import {EmpresaModule} from "./modules/cadastro/empresa/empresa.module";
import {GestaoModule} from "./modules/gestao/gestao.module";
import {AjudaModule} from "./modules/ajuda/ajuda.module";

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => AuthModule
  },
  {
    path: '',
    loadChildren: () => HomeModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'sucesso-assinatura',
    loadChildren: () => HomeModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'erro-assinatura',
    loadChildren: () => HomeModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'gestao',
    loadChildren: () => GestaoModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'cadastro',
    loadChildren: () => CadastroModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'juridico',
    loadChildren: () => JuridicoModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'empresa',
    loadChildren: () => EmpresaModule
  },
  {
    path: 'ajuda',
    loadChildren: () => AjudaModule
  },
  {
    path: '**',
    pathMatch: "full",
    loadChildren: () => ErroModule
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
